<template>
  <div class="index-container">
    <Header :nosearch="true" :title="`用户登录`" :back="true"/>
    <div class="login-warp">
      <div class="input-box">
        <p>+86</p>
        <input type="text" maxlength="11" v-model="phone" placeholder="请输入手机号">
        <i class="icon-close" @click="phone = ''"></i>
      </div>
      <div class="input-box">
        <p>验证码</p>
        <input type="text" maxlength="6" v-model="captcha" placeholder="验证码">
        <div :class="{disable: !phone || phone.length !== 11 || hasCaptcha}" @click="codeSend" class="captcha-btn">{{captchaText}}</div>
      </div>
      <div class="protocol-box">
        <input class="input-checkbox" type="checkbox" name="category" v-model="isChoose" />
        <p>同意<span style="color: #409AFB" @click="goProtocol">《用户协议》</span></p>
      </div>
      <div class="login-btn" :class="{'disable': !phone || phone.length !== 11 || !captcha || !isChoose}" @click="loginApi">
        立即登录
      </div>
      <p style="text-align: center">未注册手机号将自动创建账户</p>
    </div>
    <Toast v-if="showToast" :text="toastText"></Toast>
  </div>
</template>

<script type="text/ecmascript-6">
import { mapState, mapMutations } from 'vuex'
import { request } from '@/api/request'
import { setFreesend, login } from '@/api'
import Header from '@/components/header.vue'
import Toast from '@/components/toast.vue'
const TEL_REGEXP = /^1([3456789]\d|5[0-35-9]|7[3678])\d{8}$/
export default {
  components: { Header, Toast },
  data () {
    return {
      phone: '',
      captcha: '',
      captchaText: '获取验证码',
      codeNum: 60,
      timeInterval: null,
      hasCaptcha: false,
      smsToken: '3f4628b1c9634e04847eaeaca8b9eac6_71999',
      errText: '',
      toastText: '登录成功',
      showToast: false,
      isChoose: false
    }
  },
  computed: {
    ...mapState(['status', 'code', 'market', 'stockname', 'userInfo']),
  },
  methods: {
    _toast (toastText, time = 3000) {
      this.toastText = toastText
      this.showToast = true
      setTimeout(() => {
        this.showToast = false
      }, time)
    },
    clearInfo () {
      this.codeNum = 60
      this.smsToken = ''
      this.phone = ''
      this.captcha = ''
      this.captchaText = '获取验证码'
      clearInterval(this.timeInterval)
    },
    codeSend () {
      if (!this.phone || this.phone.length !== 11 || this.hasCaptcha) return
      this.errText = ''
      if (!this.phone || !this.phone.match(TEL_REGEXP)) {
        this._toast('请输入正确的手机号')
        return
      }
      this.setFreesendApi()
    },
    async setFreesendApi () {
      const params = {
        phone: this.phone,
        signature: 'yintech_hxgyzm',
        activityId: '10000000',
        reffer: '10000000'
      }
      try {
        const res = await setFreesend(params)
        const { code, token, msg } = res
        if (code === 1) {
          this.smsToken = token
          this.hasCaptcha = true
          this.codeNum = 60
          this.captchaText = `${this.codeNum}s`
          this.timeInterval = setInterval(() => {
            if (this.codeNum === 0) {
              clearInterval(this.timeInterval)
              this.captchaText = '获取验证码'
              this.hasCaptcha = false
            } else {
              this.codeNum -= 1
              this.captchaText = `${this.codeNum}s`
            }
          }, 1000)
          this._toast('验证码已发送')
        } else {
          this._toast('msg')
        }
      } catch (error) {
        console.log(error, '=============')
      }
      
    },
    async loginApi () {
      if (!this.phone || this.phone.length !== 11 || !this.captcha || !this.isChoose) return
      const { phone, captcha, smsToken, } = this
      const params = {
        phone,
        captcha,
        smsToken,
        serverId: 200,
        activityId: '10000000',
        reffer: '10000000'
      }
      const res = await login(params)
      const { code, data } = res
      if (code === 1) {
        this.$store.commit('setUserInfo', data)
        this._toast('登录成功')
        this.clearInfo()
        setTimeout(() => {
          this.goBack()
        }, 1500)
      } else {
        this._toast('验证码错误')
      }
    },
    goProtocol() {
      this.$router.push({
        path: `/protocol/:market/:code/:id.html`,
      })
    },
    goBack() {
      this.$router.back()
    }
  }
}
</script>

<style lang="stylus" scoped>
.icon-close
  display inline-block
  width 16px
  height 16px
  background url('../../assets/icon-close.png')
  background-size 100% 100%
.index-container
  // width 100%
  height 100vh
  background #fff
  color #999999
.login-warp
  padding 0 12px
  padding-top 128px

.login-btn
  width 100%
  height 46px
  margin-top 40px
  margin-bottom 16px
  line-height 46px
  text-align center
  border-radius 2px
  background #F43737
  color #fff
  &.disable
    background:rgba(244,55,55,0.3)

.protocol-box
  display flex
  align-items center
.input-checkbox
  width 18px
  height 18px
  border 1px solid #DCDCDC
  margin-right 7px

.input-box
  display flex
  align-items center
  margin-bottom 10px
  padding 10px 0
  border-bottom 1px solid #f5f5f5
  font-size 13px
  color #fff
  input
    width 0
    flex 1
    border none
    font-size 18px
    outline none
  p
    font-size 18px
    color #333
    min-width 70px
    margin-right 10px
    white-space nowrap
.captcha-btn
  // display inline-block
  width 86px
  height 32px
  line-height 32px
  background rgba(244,55,55,1)
  border-radius 2px
  text-align center
  align-items center
  &.disable
    background #ccc
</style>